// removed by extract-text-webpack-plugin
module.exports = {"root":"root","SFE":"SFE","skip-link":"skip-link","sr-only-focusable":"sr-only-focusable"};